@if (selectedZaehler?.isSmartMeter) {
  <div class="re-form-item-container">
    {{ 'meterreadings.smartmeter.readingInfo' | translate }}
    <button class="bdo-nolink re-block re-mt-30" type="button" (click)="closeMessage()">
      <div class="bold"> {{ 'general.action.cancel' | translate }} </div>
    </button>
  </div>
} @else {
  @if (meterreading?.zaehlwerkeListe?.length > 1) {
    <div class="zaehler-select__hint re-mb-10 re-container__content">
      {{ 'meterreadings.input.hintMoreRegister' | translate }}
    </div>
  }
  @if (saveMeterError) {
    <div class="bdo-container--single re-mt-10">
      @if (saveMeterError === SaveMeterError.METER_ALREADY_BILLED) {
        <bdo-info-box>
          {{ 'meterreadings.error.meterAlreadyBilled' | translate }}
        </bdo-info-box>
      }
      @if (saveMeterError === SaveMeterError.METERREADING_EXISTS) {
        <bdo-info-box [type]="'warning'">
          {{ 'meterreadings.error.meterreadingExists' | translate }}
        </bdo-info-box>
      }
      @if (saveMeterError === SaveMeterError.NO_ACTIVE_CONTRACT) {
        <bdo-info-box>
          {{ 'meterreadings.error.meterBeforeMovein' | translate }}
        </bdo-info-box>
      }
      @if (saveMeterError === SaveMeterError.DEFAULT) {
        <bdo-info-box>
          {{ 'meterreadings.error.general' | translate }}
        </bdo-info-box>
      }
    </div>
  }
  <form class="re-relative" (ngSubmit)="save()" bdoScrollToInvalidControl [bdoScrollToInvalidControlForm]="readingForm" [attr.aria-label]="'aria.form.meterReading' | translate: {meterNumber: selectedZaehler?.meterNumber}">
    <div class="bdo-loading__wrapper">
      <fieldset name="meter-reading-input-form" class="re-mb-0" [attr.aria-label]="'aria.fieldset.meterReadingInput' | translate">
        @if (state === LoadingState.LOADING) {
          <bdo-loading></bdo-loading>
        }
        @if (zaehleridentifiers?.length>0) {
          <div>
            <div class="bdo-form-item-container">
              @if (meterreading) {
                <bdo-date-picker
                  [labelText]="'meterreadings.info.meterreadingDate' | translate"
                  [minDateForChanges]="meterreading?.minDateForChanges"
                  [maxDateForChanges]="meterreading?.maxDateForChanges"
                  [selectedDate]="selectedDate"
                  [tooltipContent]="'meterreadings.edit.description' | translate"
                  [attr.data-qa_mindateforchanges]="meterreading?.minDateForChanges"
                  (focus)="resetData(false)"
                  (dateSelected)="onDateSelected($event)">
                </bdo-date-picker>
              }
              @if (readingExists) {
                <bdo-info-box [type]="'warning'">
                  {{ 'meterreadings.error.dateAlreadyRegistered' | translate }}
                </bdo-info-box>
              }
            </div>
            @for (zaehlwerk of meterreading?.zaehlwerkeListe; track zaehlwerk) {
              <div
                class="meter-content__meterData bdo-form-item-container">
                <bdo-input #meterInput
                  [attr.data-qa]="'meterreadingInput-' + zaehlwerk.zaehlwerknummer"
                  [validationIconHidden]="validationIconHidden"
                  [formControl]="$any(readingForm?.get('reading-' + zaehlwerk.zaehlwerknummer))"
                  placeholder="{{ 'meterreadings.meterreadingIn' | translate }} {{zaehlwerk.einheit | unitPretty}} {{ '' | zaehlwerktyp: zaehlwerk.typ }}"
                  [tooltipContent]="meterreadingInfoService.getInfo(selectedZaehler?.sparte)" (focus)="resetData(false)">
                </bdo-input>
              </div>
            }
            @if (implausible) {
              <div>
                <bdo-info-box [type]="'warning'">
                  {{ 'meterreadings.input.confirmMeterreading' | translate }}
                </bdo-info-box>
                <div class="bdo-form-item-container">
                  <bdo-checkbox
                    [required]="true"
                    [checked]="checked"
                    (change)="checked=!checked">
                    {{ 'meterreadings.input.confirmation' | translate }}
                  </bdo-checkbox>
                </div>
              </div>
            }
            <button class="bdo-button-primary re-mb-30" type="submit" [disabled]="state === LoadingState.LOADING">
              {{ 'general.action.save' | translate }}
            </button>
          </div>
        }
        @if (!zaehleridentifiers || zaehleridentifiers?.length===0) {
          <div class="re-mb-30">
            {{ 'general.error.noValues' | translate }}
          </div>
        }
        <button class="bdo-nolink" type="button" (click)="done.emit(true)">
          <div class="bold"> {{ 'general.action.cancel' | translate }} </div>
        </button>
      </fieldset>
    </div>
  </form>
}
